// extracted by mini-css-extract-plugin
module.exports = {"NewFeatureCheckout":"hg_a bhj_bi","NewFeatureCheckout__explainLink":"hg_b bhj_uq bhj_rc"};